import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import * as actions from '../../state/actions/global-settings'
import AddServiceLevelModal from 'src/components/global-settings/AddServiceLevelModal'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {}
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    createServiceLevel: (payload: { name: string }) => dispatch(actions.createServiceLevel(payload))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddServiceLevelModal)



// WEBPACK FOOTER //
// ./src/containers/global-settings/AddServiceLevelModal.ts